import Home from '../Pages/home';
import NotFound from '../Pages/notfound';
import AddNote from '../Pages/create';
import Notes from '../Pages/notes';


const routes = [
  { path: '/',
    component: Home,
    exact: true,
  },
  { path: '/home',
    component: Home,
    exact: true,
  },
  { path: '/create',
    component: AddNote,
    exact: true,
  },
  { path: '/notes',
    component: Notes,
  },
  {
    component: NotFound
  }
]

export default routes;



// WEBPACK FOOTER //
// ./src/Routes/routes.js